/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const YandexMoney = (props: IconProps) => (
  <Icon {...props}>
    <path
      d="M 19.687485,10.687512 H 14.624989 V 0.5625197 c 0,-0.21656243 -0.124313,-0.41343741 -0.318937,-0.50737496 -0.194624,-0.0928124 -0.425812,-0.0675 -0.595688,0.0686243 C 13.62993,0.18789438 5.6525579,6.5897023 3.2658726,8.3964502 0.32231138,10.624512 0,11.679199 0,13.399323 V 24.187502 C 0,25.738313 1.2616851,27 2.8124965,27 H 19.687485 c 0.310499,0 0.562499,-0.251999 0.562499,-0.5625 V 11.250012 c 0,-0.310501 -0.252,-0.5625 -0.562499,-0.5625 z M 8.9639929,10.83995 c 0.605812,-0.676125 1.4911871,-0.914626 1.9766231,-0.53325 0.486,0.381938 0.388688,1.23975 -0.217125,1.915874 -0.605812,0.676124 -1.4906227,0.914623 -1.9766223,0.532687 C 8.2608681,12.373324 8.3581806,11.516075 8.9639929,10.83995 Z M 3.9374965,24.187502 14.362864,17.602883 c 0.163125,-0.102937 0.262125,-0.282374 0.262125,-0.475312 v -5.315059 h 2.812499 v 8.015618 c 0,0.24975 -0.164814,0.47025 -0.405,0.540001 z"
    />
  </Icon>
);
